/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TopBar from '../TopBar';
import SearchBar from './SearchBar';
import { getUserRepositories, getRepository } from '../../actions/repositoryActions';
import DashboardContextProvider from '../../context/DashboardContext';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    flexFlow: 'column',
    height: '100%',
    overflow: 'auto',
  },
  box: {
    height: '100%',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    height: '100%',
    width: '100%',
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    width: '100%'
  },
  content: {
    display: 'flex',
    flex: '1 1 auto',
    width: '100%',
    flexFlow: 'column',
    height: '100%',
  },
}));

function DashboardLayout({ children }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedRepo = useSelector((state) => state.repository.selected);

  useEffect(() => {
    dispatch(getUserRepositories());
    if (selectedRepo) {
      dispatch(getRepository(selectedRepo.id));
    }
  }, [dispatch]);

  return (
    <DashboardContextProvider>
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <Box>
                <TopBar displayRepo />
                <SearchBar />
              </Box>
              {children}
            </div>
          </div>
        </div>
      </div>
    </DashboardContextProvider>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default DashboardLayout;
